import React, { PureComponent } from 'react';
import { Button, ButtonGroup } from 'reactstrap';
import styled from 'styled-components';

class ButtonRadio extends PureComponent {
    static defaultProps = {
        values: [],
        multiSelect: false // Single-select by default, set to true for multi-select
    };

    state = {
        // Support both single index (legacy) and array of indices for multi-select
        indicesSelected: this.initializeSelectedIndices()
    };

    initializeSelectedIndices() {
        const { defaultValueIndex } = this.props;
        if (defaultValueIndex == null) return [];
        // If it's already an array, use it; otherwise wrap single value in array
        if (Array.isArray(defaultValueIndex)) return [...defaultValueIndex];
        return [defaultValueIndex];
    }

    onRadioBtnClick = (index, value, event) => {
        // Remove focus from button to update visual state immediately
        event.currentTarget.blur();

        const { multiSelect } = this.props;

        this.setState(
            (prevState) => {
                const isCurrentlySelected = prevState.indicesSelected.includes(index);
                let newIndices;

                if (multiSelect) {
                    // Multi-select mode: toggle selection
                    if (isCurrentlySelected) {
                        newIndices = prevState.indicesSelected.filter(i => i !== index);
                    } else {
                        newIndices = [...prevState.indicesSelected, index];
                    }
                } else {
                    // Single-select mode: only one can be selected at a time
                    if (isCurrentlySelected) {
                        newIndices = []; // Deselect if clicking the same one
                    } else {
                        newIndices = [index]; // Replace with new selection
                    }
                }
                return { indicesSelected: newIndices };
            },
            () => {
                if (this.props.onChangeValue) {
                    // Build comma-separated string of selected values
                    const selectedValues = this.state.indicesSelected
                        .map(i => this.props.values[i]?.name)
                        .filter(Boolean);

                    // Return null if nothing selected, otherwise comma-separated string (or single value)
                    const resultValue = selectedValues.length === 0 ? null : selectedValues.join(',');
                    this.props.onChangeValue(resultValue);
                }
            }
        );
    };

    isActive(index) {
        return this.state.indicesSelected.includes(index);
    }

    render() {
        return (
            <StyledButtonGroup>
                {this.props.values.map((item, index) => (
                    <Button
                        key={item.name}
                        className={
                            this.isActive(index) ? this.props.onActiveStyle : this.props.className
                        }
                        onClick={(e) => this.onRadioBtnClick(index, item.name, e)}>
                        {item.name}
                    </Button>
                ))}
            </StyledButtonGroup>
        );
    }
}

const StyledButtonGroup = styled(ButtonGroup)`
    width: 100%;
`;

export default ButtonRadio;
